<template>
  <button
    type="button"
    class="button"
    :class="{ 'is-pulled-right': pulledRight }"
    @click="$emit('click')">
    {{ caption }}
  </button>
</template>

<script>
export default {
  props: {
    caption: {
      type: String,
      default: 'Nieuw'
    },
    pulledRight: {
      type: Boolean,
      default: true
    }
  }
}
</script>
